import { render, staticRenderFns } from "./AdminViewNeedDetailsDialog.vue?vue&type=template&id=0b80e50d&scoped=true"
import script from "./AdminViewNeedDetailsDialog.vue?vue&type=script&lang=js"
export * from "./AdminViewNeedDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./AdminViewNeedDetailsDialog.vue?vue&type=style&index=0&id=0b80e50d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b80e50d",
  null
  
)

export default component.exports